module.exports = __webpack_public_path__ + "img/我的邀请.304b3325.png";